export default __webpack_public_path__ + "static/media/restore.59504de9.svg";